import React, { useEffect } from "react";
import RequestUniqueId from "../../../../Diathrive/src/containers/RequestUniqueId";
import { useLocation, useNavigate } from "react-router-dom";
import UniqueIdContainer from "../../components/modules/UniqueIdContainer";

const RequestUniqueID = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  // redirecting user back to login if accessed this path directly instead of from sig-up
  useEffect(() => {
    if (location?.state?.prevPath !== "/sign-up") {
      navigate("/login", { replace: true });
    }
  }, [location]);

  return (
    <UniqueIdContainer testIdScreenName="RequestUniqueId">
      <RequestUniqueId navigation={navigate} />
    </UniqueIdContainer>
  );
};

export default RequestUniqueID;
